import { render, staticRenderFns } from "./Token.vue?vue&type=template&id=3e9df341&scoped=true"
import script from "./Token.vue?vue&type=script&lang=js"
export * from "./Token.vue?vue&type=script&lang=js"
import style0 from "./Token.vue?vue&type=style&index=0&id=3e9df341&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9df341",
  null
  
)

export default component.exports